import { FC } from 'react';

import { useFormik } from 'formik';
import { Plus } from 'lucide-react';
import { toast } from 'sonner';
import useSWRMutation from 'swr/mutation';

import Button from '@mui/material/Button';

import { initialValues, StreamerWheelForm, validationSchema } from '../form';
import { StreamerWheelFormFields } from '../streamerWheelFormFields/StreamerWheelFormFields';
import { mapFormToDto } from '../utils';

import css from './AddStreamerWheelForm.module.css';

import { streamerWheelService } from 'v2/api/streamerWheelService';
import { Card } from 'v2/components/card/Card';
import { CardHeader } from 'v2/components/card/cardHeader/CardHeader';
import { handleHttpError } from 'v2/utils';

interface AddStreamerWheelFormProps {
  onSuccess: VoidFunction;
}

export const AddStreamerWheelForm: FC<AddStreamerWheelFormProps> = ({ onSuccess }) => {
  const { trigger, isMutating } = useSWRMutation('createStreamerWheel', streamerWheelService.createStreamerWheel);

  const formik = useFormik<StreamerWheelForm>({
    initialValues,
    validationSchema,
    validateOnChange: false,
    validateOnBlur: true,
    onSubmit: async (values, { resetForm }) => {
      try {
        await trigger(mapFormToDto(values));
        onSuccess();
        toast.success('Streamer Wheel created successfully');
        resetForm({ values: initialValues });
      } catch (error) {
        handleHttpError(error);
      }
    },
  });

  return (
    <Card className={css.addStreamerWheelFormContainer}>
      <CardHeader title="Create Wheel" icon={Plus} />

      <form className="form" onSubmit={formik.handleSubmit}>
        <StreamerWheelFormFields formik={formik} />

        <Button type="submit" loading={isMutating} variant="contained" size="large">
          Create
        </Button>
      </form>
    </Card>
  );
};
